import { render, staticRenderFns } from "./PAQuote.vue?vue&type=template&id=167e032b&"
import script from "./PAQuote.vue?vue&type=script&lang=js&"
export * from "./PAQuote.vue?vue&type=script&lang=js&"
import style0 from "./PAQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAQuote.vue"
export default component.exports